import {
  GeniallyContext,
  UserContext,
  type WorkspaceContext,
  type WorkspaceMemberContext,
} from '@genially/snowplow-contracts';
import { CommonEventProperties, SelfDescribingEvent } from '@snowplow/browser-tracker';

import { mapAllContextsAsArray } from '../utils/mapAllContextsAsArray';

export enum GridEditedProperty {
  Preset = 'preset',
  Colour = 'colour',
  Custom = 'custom',
}

export const getGridEditedEvent = ({
  genially,
  team,
  teamMember,
  user,
  editedProperties,
}: {
  genially: GeniallyContext;
  team?: WorkspaceContext;
  teamMember?: WorkspaceMemberContext;
  user: UserContext;
  editedProperties: GridEditedProperty[];
}): SelfDescribingEvent & CommonEventProperties => ({
  event: {
    schema: 'iglu:com.genially/grid_edited/jsonschema/1-0-0',
    data: {
      grid_type: editedProperties.join(','),
    },
  },
  context: mapAllContextsAsArray({
    genially,
    team,
    teamMember,
    user,
  }),
});
